import React, { useEffect, useState } from "react";
import { Card, CardBody, CardHeader, Col, Form, InputGroup, Row } from "react-bootstrap";
import { studyOnboardingService } from "../../Services/studyServices/studyOnboarding";
import { supplimentaryServices } from "../../Services/CDISC/supplimentaryServices";
import { useParams } from "react-router";
import { FaRegEdit } from "react-icons/fa";
import { AiOutlineDelete } from "react-icons/ai";
import Swal from "sweetalert2";
import { MdAddBox } from "react-icons/md";

const StudyConfiguration = () => {
  const [versionList, setVersionList] = useState([]);
  const [studyVersionList, setStudyVersionList] = useState([]);
  const [studyVersionId, setStudyVersionId] = useState("");
  const [studyVersion, setStudyVersion] = useState("");
  const [studyVersionDT, setStudyVersionDT] = useState("");
  const [selectedVersion, setSelectedVersion] = useState("");
  const [selectedStudyVersion, setSelectedStudyVersion] = useState("");
  const [selectedCRFData, setSelectedCRFData] = useState("");
  const [randomizerPrefix, setRandomizerPrefix] = useState("");
  const [randomizerSufix, setRandomizerSufix] = useState("");
  const [randomizerStart, setRandomizerStart] = useState("");
  const [notificationType, setNotificationType] = useState("");
  const [notificationDuration, setNotificationDuration] = useState("");
  const [notifyStartDate, setNotifyStartDate] = useState("");

  const { studyId } = useParams()
  const configurationStudyID = async (type, value) => {
    let userData = {}
    if (type === "notificationType") {
      userData.notificationType = value
    }
    if (type === "notificationDuration") {
      userData.notificationDuration = value
    }
    if (type === "notifyStartDate") {
      userData.notifyStartDate = value
    }
    if (type === "notificationData") {
      userData.notificationType = "dynamic"
      userData.notificationDuration = value
    }
    if (type === "crfType") {
      userData.crfType = value
    }
    if (type === "randomizerPrefix") {
      userData.randomizerPrefix = value
    }
    if (type === "randomizerSufix") {
      userData.randomizerSufix = value
    }
    if (type === "randomizerStart") {
      userData.randomizerStart = value
    }
    if (type === "studyVersion") {
      userData.studyVersion = value?.version
      userData.studyVersionDT = value?.date
    }
    userData.studyId = studyId
    await studyOnboardingService.configurationStudyID(userData)
    getSingleStudies()
  }
  const getActiveVersions = async () => {
    let data = await supplimentaryServices.getActiveVersions()
    setVersionList(data?.data || [])
  }
  const getStudyVersion = async () => {
    let data = await studyOnboardingService.getStudyVersion(studyId)
    setStudyVersionList(data?.data || [])
  }
  const addStudyVersion = async () => {
    let userData = {
      studyID: studyId,
      studyVersion: studyVersion,
      studyVersionDT: studyVersionDT
    }
    await studyOnboardingService.addStudyVersion(userData)
    getStudyVersion()
    setStudyVersion("")
    setStudyVersionDT("")
  }
  const updateStudyVersion = async () => {
    let userData = {
      studyID: studyId,
      id: studyVersionId,
      studyVersion: studyVersion,
      studyVersionDT: studyVersionDT
    }
    await studyOnboardingService.updateStudyVersion(userData)
    getStudyVersion()
    setStudyVersionId("")
    setStudyVersion("")
    setStudyVersionDT("")
  }
  const deleteStudyVersion = async (e, id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Delete this Study Version!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        e.preventDefault();
        let result = await studyOnboardingService.deleteStudyVersion(id, studyId);
        if (result?.statusCode === 200) {
          getStudyVersion();
        }
      }
    });
  };
  const getSingleStudies = async () => {
    let data = await studyOnboardingService.getSingleStudies(studyId)
    setSelectedVersion(data?.data?.[0]?.version || "")
    setSelectedCRFData(data?.data?.[0]?.crfType || "")
    setRandomizerPrefix(data?.data?.[0]?.randomizerPrefix || "")
    setRandomizerSufix(data?.data?.[0]?.randomizerSufix || "")
    setRandomizerStart(data?.data?.[0]?.randomizerStart || "")
    setNotificationType(data?.data?.[0]?.notificationType || "")
    setNotificationDuration(data?.data?.[0]?.notificationDuration || "")
    setNotifyStartDate(data?.data?.[0]?.notifyStartDate || "")
    setSelectedStudyVersion(data?.data?.[0]?.studyVersion || "")
  }

  useEffect(() => {
    getActiveVersions();
    getSingleStudies();
    getStudyVersion()
  }, []);
  return (
    <div className="p-3 overflow-auto" style={{ height: "calc(100vh - 155px)" }}>
      <div style={{ fontSize: 14, color: "#103c5e", fontWeight: 500, marginTop: -7 }} className="mb-1">SDTM Settings</div>
      <div className="d-flex gap-3 w-100 m-auto">
        <Card className="w-100">
          <CardHeader className="fontSize12">Version Settings</CardHeader>
          <CardBody>
            {versionList?.map((item, index) => (
              <div className="hstack gap-2">
                <Form.Check
                  onChange={(e) => configurationStudyID("version", item._id)}
                  key={index}
                  type="radio"
                  checked={selectedVersion === item._id}
                  name="version" />
                <Form.Label className="mb-1">{item?.version}</Form.Label>
              </div>
            ))}
          </CardBody>
        </Card>
        <Card className="w-100">
          <CardHeader className="fontSize12">CRF Data Settings</CardHeader>
          <CardBody>
            <div className="hstack gap-2">

              <Form.Check
                onChange={(e) => configurationStudyID("crfType", "custom")}
                type="radio"
                checked={selectedCRFData === "custom"}
                name="crf"
              />
              <Form.Label className="mb-1">Custom</Form.Label>
            </div>
            <div className="hstack gap-2">
              <Form.Check
                onChange={(e) => configurationStudyID("crfType", "predefined")}
                type="radio"
                checked={selectedCRFData === "predefined"}
                name="crf" />
              <Form.Label className="mb-1">Predefined</Form.Label>
            </div>
          </CardBody>
        </Card>
      </div>
      <div style={{ fontSize: 14, color: "#103c5e", fontWeight: 500, marginTop: 14 }} className="mb-0">IWRS Settings</div>
      <Row className="">
        <Form.Group className="mb-0" as={Col} md={4}>
          <Form.Label style={{ fontWeight: 500 }}>Prefix:</Form.Label>
          <Form.Control
            onChange={(e) => configurationStudyID("randomizerPrefix", e.target.value)}
            value={randomizerPrefix}
            type="text"
            placeholder="Add Prefix"
          />
        </Form.Group>
        <Form.Group className="mb-0" as={Col} md={4}>
          <Form.Label style={{ fontWeight: 500 }}>Suffix:</Form.Label>
          <Form.Control
            onChange={(e) => configurationStudyID("randomizerSufix", e.target.value)}
            value={randomizerSufix}
            type="text"
            placeholder="Add Suffix"
          />
        </Form.Group>
        <Form.Group className="mb-0" as={Col} md={4}>
          <Form.Label style={{ fontWeight: 500 }}>Starting Number:</Form.Label>
          <Form.Control
            onChange={(e) => configurationStudyID("randomizerStart", e.target.value)}
            value={randomizerStart}
            type="number"
            placeholder="Add Starting Number"
          />
        </Form.Group>
      </Row>
      <div style={{ fontSize: 14, color: "#103c5e", fontWeight: 500, marginTop: 14 }} className="mb-1">EDC Settings</div>
      <div className="d-flex gap-3 w-100 m-auto">
        <Card className="w-100">
          <CardHeader className="fontSize12">Notification Settings</CardHeader>
          <div className="d-flex gap-2">
            <CardBody>
              <div className="hstack gap-2">
                <Form.Check
                  type="radio"
                  name="radio"
                  checked={notificationType === "custom"}
                  onChange={() => { configurationStudyID("notificationType", "custom"); setNotificationType("custom") }}
                />
                <Form.Label className="mb-1">Custom</Form.Label>
              </div>

              {notificationType === "custom" && (
                <InputGroup className="mb-2 w-25">
                  <Form.Control
                    type="number"
                    className="rounded-0"
                    placeholder="Fill no of days"
                    value={notificationDuration}
                    onChange={(e) => { configurationStudyID("notificationDuration", e.target.value) }}
                  />
                  <button
                    className="fontSize12 text-white br-3 updateProfile"
                    style={{ background: "#103c5e" }}
                  >
                    Days
                  </button>
                </InputGroup>
              )}

              <div className="hstack gap-2">
                <Form.Check
                  type="radio"
                  name="radio"
                  checked={notificationDuration === "daily"}
                  onChange={() => { configurationStudyID("notificationData", "daily") }}
                />
                <Form.Label className="mb-1">Daily</Form.Label>
              </div>

              <div className="hstack gap-2">
                <Form.Check
                  type="radio"
                  name="radio"
                  checked={notificationDuration === "weekly"}
                  onChange={() => { configurationStudyID("notificationData", "weekly") }}
                />
                <Form.Label className="mb-1">Weekly</Form.Label>
              </div>

              <div className="hstack gap-2">
                <Form.Check
                  type="radio"
                  name="radio"
                  checked={notificationDuration === "monthly"}
                  onChange={() => { configurationStudyID("notificationData", "monthly") }}
                />
                <Form.Label className="mb-1">Monthly</Form.Label>
              </div>
            </CardBody>
            <CardBody>
              <Form.Label className="mb-1"><b>Notify Start Date</b></Form.Label>
              <InputGroup className="mb-2 w-100">
                <Form.Control
                  type="date"
                  className="rounded-0"
                  value={notifyStartDate}
                  onChange={(e) => { configurationStudyID("notifyStartDate", e.target.value) }}
                />
              </InputGroup>
            </CardBody>
          </div>
        </Card>
        <Card className="w-100">
          <CardHeader className="fontSize12 hstack justify-content-between">
            <div>
              Study Version Settings
            </div>
            {studyVersionId &&
              <div>
                <MdAddBox
                  onClick={(e) => { setStudyVersionId(""); setStudyVersion(""); setStudyVersionDT("") }}
                  title="Add New Version"
                  className="CP"
                  style={{ fontSize: 18 }}
                />
              </div>
            }
          </CardHeader>
          <CardBody>
            <InputGroup className="mb-2">
              <Form.Control
                type="text"
                onChange={(e) => setStudyVersion(e.target.value)}
                value={studyVersion}
                placeholder="Enter Version"
                className="rounded-0"
              />
              <Form.Control
                type="date"
                className="rounded-0"
                onChange={(e) => setStudyVersionDT(e.target.value)}
                value={studyVersionDT}
              />
              {studyVersionId ?
                <button onClick={updateStudyVersion} className="updateProfile">Update</button>
                :
                <button onClick={addStudyVersion} className="updateProfile">Add</button>
              }
            </InputGroup>
            <div className="overflow-auto" style={{ maxHeight: 80 }}>
              {studyVersionList?.map((item, index) => (
                <div key={index} className="hstack gap-2">
                  <Form.Check
                    onChange={(e) => configurationStudyID("studyVersion", { version: item.studyVersion, date: item?.studyVersionDT })}
                    checked={selectedStudyVersion === item.studyVersion}
                    type="radio"
                    name="studyGroup"
                  />
                  <Form.Label className="mb-1">{item?.studyVersion} &nbsp;&nbsp;&nbsp;<b>({item?.studyVersionDT})</b></Form.Label>&nbsp;&nbsp;&nbsp;
                  <FaRegEdit onClick={(e) => { setStudyVersionId(item?._id); setStudyVersion(item?.studyVersion); setStudyVersionDT(item?.studyVersionDT) }} className="CP mb-1" title="Update Study Version" style={{ fontSize: 13 }} />
                  <AiOutlineDelete onClick={(e) => deleteStudyVersion(e, item?._id)} className="mb-1 CP text-danger" title="Delete this Study Version" style={{ fontSize: 14 }} />
                </div>
              ))}
            </div>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default StudyConfiguration;
